import { Component, OnInit } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ApiService } from 'src/app/api.service';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { AuthenticationService } from 'src/app/_services';
import { TovpilUtilsService } from 'src/app/utils/tovpil-utils.service';
import { SecurityDocument } from 'src/app/shared/models/SecurityDocument';
import { TranslateRelLabelVO } from 'src/app/shared/models/TranslateRelLabelVO';
import { first } from 'rxjs/operators';
import { TovpilFilesService } from 'src/app/utils/tovpil-files.service';
import { PurchOrdSupLst } from 'src/app/shared/models/PurchOrdSupLst';
import { Constants } from 'src/app/shared/vo/Constants';
import { TovpilLanguageService } from 'src/app/utils/tovpil-language.service';

@Component({
  selector: 'app-purch-ord-sup-lst',
  templateUrl: './purch-ord-sup-lst.component.html',
  styleUrls: ['./purch-ord-sup-lst.component.scss'],
  providers: [MessageService, ConfirmationService]
})
export class PurchOrdSupLstComponent implements OnInit {

  /** SECURITY */
  currentUser: any;
  security: SecurityDocument;
  token: string;
  device: string;
  storeId: string;

  /** LABELS */
  translations: Record<string, string> = {};
  lstCols: { field: string; header: any; }[];

  /** COMPONENT */

  orderList: PurchOrdSupLst[];
  purchOrdSup?: PurchOrdSupLst;
  selectedPurchOrdSup: PurchOrdSupLst[] = [];
  listSuppliers: any[];
  selectedSupplier: any;

  statusList: any[];
  currencyList: any[];
  nameList: any[];
  dataParent: any;

  tableName: string;
  blocked: boolean = true;

  /**
   * This is a constructor function that initializes various services and variables used in the
   * component.
   * @param {MessageService} messageService - This parameter is of type MessageService and is used for
   * displaying messages to the user.
   * @param {PurchOrdSupLstService} purchOrdSupLstServiceTest - This parameter is an instance of the
   * PurchOrdSupLstService class. It is used to perform operations related to the purchase order
   * supplier list.
   * @param {ConfirmationService} confirmationService - This parameter is used to display confirmation
   * dialogs to the user. It is provided by the ConfirmationService class.
   * @param {ApiService} apiService - An instance of the ApiService class, which is responsible for
   * making API calls.
   * @param {Router} router - The `router` parameter is used for routing and navigation in Angular. It
   * allows you to navigate to different components and pass data between them.
   * @param {ActivatedRoute} route - The `route` parameter is used to access the current route's
   * information, such as the URL parameters and query parameters. It is an instance of the
   * `ActivatedRoute` class, which is provided by the Angular Router.
   * @param {AuthenticationService} authenticationService - This parameter is used to authenticate the
   * user and manage user-related functionalities such as login, logout, and user information.
   * @param {TovpilUtilsService} tovpilUtils - TovpilUtilsService is a service that provides utility
   * functions for the Tovpil application. It may include functions for formatting data, manipulating
   * strings, or performing common calculations.
   * @param {TovpilFilesService} filesService - TovpilFilesService is a service that handles file-related
   * operations such as uploading, downloading, and deleting files.
   */
  constructor(private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private apiService: ApiService,
    private router: Router,
    private route: ActivatedRoute,
    private authenticationService: AuthenticationService,
    private tovpilUtils: TovpilUtilsService,
    private translationService: TovpilLanguageService,
    private filesService: TovpilFilesService) {

    this.tableName = this.getTableName();
    this.route.queryParams.subscribe(
      params => {
        this.token = params.token;
        this.device = params.device;
        this.storeId = params.storeId;
      });

    const navigation = this.router.getCurrentNavigation();
    this.dataParent = navigation.extras.state as any;
    console.log(this.dataParent);
    if (this.token) {
      if (this.device && this.device == "2") {
        this.autenthicateByZuul('generalaccess', 'hY6Mn_4hn9vDrWrh6');
      }
    } else {
      this.currentUser = this.authenticationService.currentUserValue;
    }
  }

  /**
   * The ngOnInit function initializes the component by setting the currentUser property to the current
   * user value from the authentication service and calling the getSecurity function.
   */
  ngOnInit(): void {
    this.currentUser = this.authenticationService.currentUserValue;
    // console.log(this.currentUser);
    this.getSecurity();
  }

  /**
   * The function `autenthicateByZuul` authenticates a user by calling the `login` method of the
   * `authenticationService` and then performs additional actions based on the response.
   * @param {string} user - A string representing the username or user identifier.
   * @param {string} password - The `password` parameter is a string that represents the user's password.
   */
  autenthicateByZuul(user: string, password: string) {
    this.authenticationService.login(user, password)
      .pipe(first())
      .subscribe(
        data => {
          if (data.code == 'R-0200') {
            this.getSecurity();
          } else {
          }
        },
        error => {
        });
  }

  /**
   * The function `getSecurity()` retrieves security data and then calls another function to get
   * translated labels.
   */
  getSecurity() {
    if (!this.security) {
      this.apiService.findSecurityById({ "id": this.currentUser.tokenProfile }).then(
        data => {
          this.security = data;
          this.getTranslatedLabels();
          this.lstSuppliersBySupStoreId();

        });
    } else {
      this.getTranslatedLabels();
    }
  }


  /**
   * The function `loadPurchOrdSup` loads purchase order data and populates various lists based on the
   * data.
   */
  loadPurchOrdSup() {
    this.blocked = true;

    const requestParams = {
      "supplStoreId": this.selectedSupplier.storeId,
      "language": this.security.language
    };

    this.apiService.findPurchordhBysupplStoreId(requestParams)
      .then(data => {
        this.orderList = data;
        // Handle success or error
        this.handleSuccess();
      })
      .catch(error => {
        console.error("An error occurred while fetching purchase order data:", error);
        this.handleError();
      })
      .finally(() => {
        setTimeout(() => {
          this.blocked = false;
        }, 1500);
      });
  }

  private handleSuccess() {
    // Data manipulation similar to lstCordinationCatalog
    this.currencyList = this.orderList
      .filter(item => item && item.currDesc !== null && item.currDesc !== undefined)
      .map(item => ({ label: item.currDesc.trim().toUpperCase(), value: item.currDesc.trim().toUpperCase() }))
      .filter((status, index, self) => self.findIndex(s => s.label === status.label) === index);

    this.statusList = this.orderList
      .filter(item => item && item.stsDesc !== null && item.stsDesc !== undefined)
      .map(item => ({ label: item.stsDesc.trim().toUpperCase(), value: item.stsDesc.trim().toUpperCase() }))
      .filter((status, index, self) => self.findIndex(s => s.label === status.label) === index);

    this.nameList = this.orderList
      .filter(item => item && item.storeDesc !== null && item.storeDesc !== undefined)
      .map(item => ({ label: item.storeDesc.trim().toUpperCase(), value: item.storeDesc.trim().toUpperCase() }))
      .filter((name, index, self) =>
        self.findIndex(s => s.label === name.label && s.value === name.value) === index
      );
    this.orderList = this.orderList.filter(val => val.ordH.status != Constants.CANCEL_DELETE_STATUS);

  }

  private handleError() {
    this.goBack();
    console.error("An error occurred while parsing.");
    this.messageService.add({
      severity: 'error',
      summary: 'Error',
      detail: 'Hubo un problema al procesar la información. Por favor, recargue la página e inténtelo nuevamente más tarde.',
      life: 5000
    });
  }

  /**
   * The function lstSuppliersBySupStoreId retrieves a list of suppliers based on the store ID and
   * language, assigns the data to the listSuppliers variable, selects the first supplier in the list,
   * and then calls the loadPurchOrdSup function.
   */
  lstSuppliersBySupStoreId() {
    this.apiService.lstSuppliersBySupStoreId(
      {
        "storeId": this.security.storeId,
        "language": this.security.language
      }
    ).then(
      data => {
        this.listSuppliers = data;
        if (data) {
          if(this.dataParent != undefined){
            this.selectedSupplier = this.dataParent.selectedSupplier ?? this.listSuppliers[0];
            this.loadPurchOrdSup();
          }
          else{
            this.selectedSupplier = this.listSuppliers[0];
            this.loadPurchOrdSup();
          }
        }
      });
  }

  /**
   * The function createPurchOrdSup is used to call a routing function.
   */
  createPurchOrdSup() {
    let obj = {
      security: this.security,
      selectedSupplier: this.selectedSupplier
    }


    let navigationExtras: NavigationExtras = {
      state: JSON.parse(JSON.stringify(obj))
    }

    this.router.navigate(['/materials/purchOrdSupDtl'], navigationExtras);
  }

  /**
   * The function `deleteSelectedPurchOrdSup` deletes selected products from a list and displays a
   * confirmation message before deleting.
   */
  deleteSelectedPurchOrdSup() {
    this.confirmationService.confirm({
      message: '¿ ' + this.translations.lbl_are_you_sure + ' ' + this.translations.lbl_delete_record + ' ?',
      header: this.translations.lbl_confirm,
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.orderList = this.orderList.filter(val => !this.selectedPurchOrdSup.includes(val));
        this.selectedPurchOrdSup = null;
        this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'Products Deleted', life: 3000 });
      }
    });
  }

  /**
   * The function `deletePurchOrdSup` deletes a product from a list and displays a confirmation message
   * before doing so.
   * @param {PurchOrdSupLst} product - The parameter "product" is an object of type
   * "PurchOrdSupLst".
   */
  deletePurchOrdSup(product: PurchOrdSupLst) {
    this.confirmationService.confirm({
      message: '¿ ' + this.translations.lbl_are_you_sure + ' ' + this.translations.lbl_delete_record + ' ' + product.ordH.orderId + ' ' + product.stsDesc + '?',
      header: this.translations.lbl_confirm,
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.purchOrdHChgSts(product.ordH.orderId, Constants.CANCEL_DELETE_STATUS);
        this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'Product Deleted', life: 3000 });
      }
    });
  }

  /**
   * The function editPurchOrdSup is used to edit a purchase order supplier.
   * @param {PurchOrdSupLst} product - The parameter "product" is of type "PurchOrdSupLst".
   */
  editPurchOrdSup(product: any) {

    let obj = {
      purchOrdH: product.ordH,
      selectedSupplier: this.selectedSupplier,
      security: this.security
    }


    let navigationExtras: NavigationExtras = {
      state: JSON.parse(JSON.stringify(obj))
    }

    this.router.navigate(['/materials/purchOrdSupDtl'], navigationExtras);

  }

  /**
   * The goBack function closes the current window.
   */
  goBack() {
    window.close();
  }

  /**
   * The function `getTranslatedLabels` is an asynchronous function that retrieves translated labels from
   * a translation service and sets them in the `translations` variable, and then calls another function
   * `getLanguages`.
   */
  async getTranslatedLabels() {
    try {
      const language = this.security.language;
      const region = this.security.region;  
      await this.translationService.getTranslatedLabels(language, region);
      this.translations = this.translationService.getLabels();
     
    } catch (error) {
      console.error("An error occurred while getting translated labels:", error);
      this.messageService.add({ severity: 'warn', summary: 'Error', detail: `Error: ${this.translations.lbl_translation} ${this.translations.lbl_language}` });
      // Error al traer labels traducidos
    }
  }

  /**
   * The exportExcel function exports a list of purchase orders to an Excel file.
   */
  exportExcel() {
    if (this.orderList === null) {
      this.messageService.add({
        severity: 'error',
        summary: 'No existe información para procesar',
        life: 3000
      });
    } else if (this.orderList.length < 1) {
      this.messageService.add({
        severity: 'error',
        summary: 'La lista está vacía',
        life: 3000
      });
    } else {
      const filteredJSON = this.orderList.map((item) => ({
        "SOLICITUD_DE_MATERIAL": item ? (item?.ordH?.orderId || 'S/N') : 'S/N',
        "FECHA_REQUERIMIENTO": item ? (item?.ordH?.ordDate || 'S/N') : 'S/N',
        "ESTATUS": item ? (item?.stsDesc || 'S/N') : 'S/N',
        "NOMBRE": item ? (item?.storeDesc || 'S/N') : 'S/N',
        "MONEDA": item ? (item?.currDesc || 'S/N') : 'S/N',
        "LENGUAJE": item ? (item?.ordH?.language || 'S/N') : 'S/N',
      }));


      this.filesService.tovpilExportXLSX(filteredJSON, 'listPurchOrdSup_');

    }
  }

  /**
   * The exportPdf function exports a PDF file based on the data in the purchOrdSupLst array.
   */
  exportPdf() {
    if (this.orderList === null) {
      this.messageService.add({
        severity: 'error',
        summary: 'No existe información para procesar',
        life: 3000
      });
    } else if (this.orderList.length < 1) {
      this.messageService.add({
        severity: 'error',
        summary: 'La lista está vacía',
        life: 3000
      });
    } else {
      const filteredJSON = this.orderList.map((item) => ({
        "SOLICITUD_DE_MATERIAL": item ? (item?.ordH?.orderId || 'S/N') : 'S/N',
        "FECHA_REQUERIMIENTO": item ? (item?.ordH?.ordDate || 'S/N') : 'S/N',
        "ESTATUS": item ? (item?.stsDesc || 'S/N') : 'S/N',
        "NOMBRE": item ? (item?.storeDesc || 'S/N') : 'S/N',
        "MONEDA": item ? (item?.currDesc || 'S/N') : 'S/N',
        "LENGUAJE": item ? (item?.ordH?.language || 'S/N') : 'S/N',
      }));


      const keysArray = filteredJSON.map((item) => Object.keys(item));
      const valuesArray = filteredJSON.map((item) => Object.values(item));

      this.filesService.tovpilExportPDF(keysArray[0], valuesArray, 'listPurchOrdSup_');

    }
  }

  /**
   * The function `getTableName` returns a formatted filename based on the current date.
   * @returns the name of a table in the format "listPurchOrdSup_yyyymmdd", where "yyyymmdd" represents
   * the current date in the format year-month-day.
   */
  getTableName() {
    const date = new Date();
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    const formattedDate = `${year}${month}${day}`;

    const filename = 'listPurchOrdSup_' + `${formattedDate}`;

    return `"${filename}"`;
  }
  purchOrdHChgSts(orderId: string, newStatus: String) {
    this.apiService.purchOrdHChgSts({
      "orderId": orderId,
      "status": newStatus
    }).then(
      data => {
        this.loadPurchOrdSup();
      });
  }
}
